"use strict";

exports.__esModule = true;
exports.buildMetricQuery = buildMetricQuery;
var _bins = require("../../Components/VIMANAMetrics/bins");
var getFilterQueryForDeviceList = function getFilterQueryForDeviceList(devices) {
  return {
    filterType: "terms",
    fieldName: "entity.device",
    values: devices,
    options: {}
  };
};
var getFilterQueryForRange = function getFilterQueryForRange(start, end) {
  return {
    filterType: "range",
    fieldName: "timestamp",
    values: {
      gte: start,
      lt: end
    },
    options: {}
  };
};

/**
 * Query Generator with byDevice aggregation
 * @param metrics
 * @returns {{filterByRange: filterByRange, filterByDevice: filterByDevice, getQuery: function(): {filters: {must: Array, mustNot: Array}, bins: *[], metrics: MetricID[]}}}
 */
function buildMetricQuery(metrics) {
  var mustFilter = [];
  var mustNotFilter = [];
  var bins = [];

  /**
   * Filter query by range
   * @param start
   * @param end
   */
  var filterByRange = function filterByRange(start, end) {
    var rangeFilterQuery = getFilterQueryForRange(start, end);
    mustFilter.push(rangeFilterQuery);
  };
  var filterByDevice = function filterByDevice(devices) {
    mustFilter.push(getFilterQueryForDeviceList(devices));
  };
  var aggregateBy = function aggregateBy(aggregateBinNames, options) {
    if (aggregateBinNames === void 0) {
      aggregateBinNames = [];
    }
    if (options === void 0) {
      options = {};
    }
    aggregateBinNames.forEach(function (aggregateName) {
      var bin = (0, _bins.getBin)(aggregateName, options);
      if (bin) {
        bins.push(bin);
      }
    });
  };

  /**
   * Get the query built
   * @returns {{filters: {must: *[], mustNot: Array}, bins: *[], metrics: *}}
   */
  var getQuery = function getQuery() {
    return {
      filters: {
        must: mustFilter,
        mustNot: mustNotFilter
      },
      bins: bins,
      metrics: metrics
    };
  };
  return {
    filterByRange: filterByRange,
    filterByDevice: filterByDevice,
    aggregateBy: aggregateBy,
    getQuery: getQuery
  };
}